<template>
    <button class="absolute top-5 right-10 rounded-md bg-blue-200 px-5 py-2" @click="logout">Logout</button>
    <div class="flex flex-col mb-20">
        <div class="w-3/5 mx-auto grid grid-cols-1 gap-4 md:grid-cols-3">
            <div class="p-6 bg-[#E3F5FF] rounded-lg text-start">
                <h3 class="font-bold">Number of users</h3>
                <h3 class="font-extrabold"> {{ this.itemsForFilter.length }}</h3>
            </div>
            <div class="p-6 bg-green-200 rounded-lg text-start">
                <h3 class="font-bold">Confirmed User</h3>
                <h3 class="font-extrabold"> {{ this.confirmedUsers }}</h3>
            </div>
            <div class="p-6 bg-red-200 rounded-lg text-start">
                <h3 class="font-bold">Unconfirmed users</h3>
                <h3 class="font-extrabold"> {{ unConfirmedUsers }}</h3>
            </div>
        </div>
        <div class="mx-auto w-4/5 mt-2 overflow-hidden rounded-md bg-white shadow">
            <div class="relative overflow-x-auto sm:rounded-lg">
                <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                    <caption
                        class="p-5 text-lg font-semibold text-left text-gray-900 bg-white dark:text-white dark:bg-gray-800">
                        Users
                        <div class="w-full flex justify-between mt-6">
                            <div>
                                <input class="px-4 py-2 border-2 border-blue-600 rounded-full text-black" v-model="searchQuery"
                                    placeholder="Search..." @input="filterItems" />
                            </div>
                            <div>
                                <button @click="doFilter" class="text-end rounded px-4 py-2 bg-blue-600 text-white">filter
                                    by {{
                                        this.filter
                                        != false ? 'Confirmed' : 'Unconfirmed' }}</button>
                                <button @click="loadAllUsers"
                                    class="ml-4 text-end rounded px-4 py-2 bg-blue-600 text-white">refresh</button>
                            </div>
                        </div>
                    </caption>
                    <thead
                        class="text-xs text-center text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" class="px-4 py-3">
                                Username
                            </th>
                            <th scope="col" class="px-4 py-3">
                                Email
                            </th>
                            <th scope="col" class="px-4 py-3">
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody class="text-center">
                        <tr v-for="user in paginatedItems" :key="user.id"
                            class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                            <th scope="row" class="px-4 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                {{ user.data.name }}
                            </th>
                            <td class="px-4 py-4">
                                {{ user.data.email }}
                            </td>
                            <td class="px-4 py-4">
                                <button @click="changeStatus(user.id, user.data)" class="p-2 rounded-md text-white"
                                    :class="{ 'bg-red-600': !user.data.isConfirmed, 'bg-green-600': user.data.isConfirmed }">
                                    {{
                                        user.data.isConfirmed ?
                                        'Confirmed' : 'Unconfirmed' }}</button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="totalPages > 0" class="flex justify-between items-center py-3 px-2">
                    <div class="px-2">
                        <p class="text-sm font-semibold text-gray-700">{{ currentPage }} - {{ currentPage * 10 }} sur {{
                            totalPages * 10 }}</p>
                    </div>
                    <div class="flex justify-center items-center">
                        <button @click="prevPage" :disabled="currentPage == 1"
                            :class="{ 'cursor-not-allowed': !currentPage == 1 }">
                            <svg class="h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="24" height="24" fill="none" />
                                <path d="M14.5 17L9.5 12L14.5 7" stroke="#000000" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </button>
                        <template v-for="link in totalPages" :key="link">
                            <div class="px-2 ">
                                <button v-if="link == currentPage" @click="handleCurrentPage(link)"
                                    class="px-4 py-2 rounded-md font-bold text-white bg-blue-600 rounded-full shadow">
                                    {{ link }}
                                </button>
                                <button v-else @click="handleCurrentPage(link)" class="px-4 py-2 rounded-md font-bold">
                                    {{ link }}
                                </button>
                            </div>
                        </template>

                        <button @click="nextPage" :disabled="currentPage === totalPages"
                            :class="{ 'cursor-not-allowed': !currentPage === totalPages }"
                            class="p-2 rounded-md hover:bg-jocker text-white">
                            <svg class="h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="24" height="24" fill="none" />
                                <path d="M9.5 7L14.5 12L9.5 17" stroke="#000000" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { db } from '@/config/firebase.js'
import { query, collection, getDocs, where, updateDoc, doc } from "firebase/firestore/lite"
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import emailjs from '@emailjs/browser';
import fireBaseService from '@/services/index.js'

export default {
    data() {
        return {
            currentPage: 1,
            items: [],
            itemsForFilter: [],
            filter: false,
            searchQuery: ''
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.items.length / 10);
        },
        paginatedItems() {
            const start = (this.currentPage - 1) * 10;
            const end = start + 10;
            return this.items.slice(start, end);
        },
        confirmedUsers() {
            return this.itemsForFilter.filter((item) => item.data.isConfirmed == true).length;
        },
        unConfirmedUsers() {
            return this.itemsForFilter.filter((item) => item.data.isConfirmed == false).length;
        }
    },
    methods: {
        async logout() {
            const logout = await fireBaseService.logout()
            if (logout) {
                this.$router.push("/login");
            }
        },
        async loadAllUsers() {
            this.items = []
            this.itemsForFilter = []
            let q = query(collection(db, "users"), where('isAdmin', "==", false));
            let response = await getDocs(q);
            response.forEach(el => {
                this.items.push({ id: el.id, data: el.data() })
                this.itemsForFilter.push({ id: el.id, data: el.data() })
            })
        },
        handleCurrentPage(index) {
            this.currentPage = index
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        async filterItems(event) {
            if (event.target.value == '') {
                this.items = []
                await this.loadAllUsers();
                return
            }
            this.items = this.items.filter((item) =>
                item.data.name.toLowerCase().includes(event.target.value.toLowerCase())
            );
        },
        async changeStatus(id, user) {
            try {
                await updateDoc(doc(db, 'users', id), { name: user.name, email: user.email, isConfirmed: !user.isConfirmed, isAdmin: false });
                let indexToUpdate = this.items.findIndex(item => item.id === id);
                this.items[indexToUpdate] = {
                    id: id,
                    data: {
                        name: this.items[indexToUpdate].data.name,
                        email: this.items[indexToUpdate].data.email,
                        isConfirmed: !this.items[indexToUpdate].data.isConfirmed,
                        isAdmin: this.items[indexToUpdate].data.isAdmin
                    }
                }
                this.itemsForFilter[indexToUpdate] = this.items[indexToUpdate]
                if (this.items[indexToUpdate].data.isConfirmed == true) {
                    emailjs.send("service_lxnp99c", "template_mo71ok5", {
                        to_name: "yes",
                        from_name: 'Confirmation from dashboard',
                        test: `${this.items[indexToUpdate].data.name} is Confirmed`,
                        name: this.items[indexToUpdate].data.name,
                        email: this.items[indexToUpdate].data.email,
                        reply_to: "q",
                        message: '',
                    },
                        '5w24LJcA1Pp27zKB-');
                    toast.success("Message envoyer");
                }
            } catch (err) {
                console.err(err)
            }
        },
        async doFilter() {
            this.filter = !this.filter
            if (this.filter) {
                await this.loadAllUsers()
                this.items = this.items.filter((e) => e.data.isConfirmed == false)
            } else {
                await this.loadAllUsers()
                this.items = this.items.filter((e) => e.data.isConfirmed == true)
            }
        }
    },
    async mounted() {
        this.items = []
        this.itemsForFilter = []
        let q = query(collection(db, "users"), where('isAdmin', "==", false));
        let response = await getDocs(q);
        response.forEach((el) => {
            this.itemsForFilter.push({ id: el.id, data: el.data() })
            return this.items.push({ id: el.id, data: el.data() })
        })
    },
};
</script>
